import { _noop } from '@client/new/helpers/general';
import { SessionSubscriber } from '../sessionTracker';
import { ClientSessionEvent } from '../sessionTracker.domain';
import * as Sentry from '@sentry/react';
/* eslint-disable @typescript-eslint/no-explicit-any */

// https://sentry.zendesk.com/hc/en-us/articles/29977058338971-Why-is-my-breadcrumb-data-being-cut-off-in-Sentry

const maxBreadCrumbSize = 7 * 1024;
const maxBreadcrumbCount = 95;
let totalSize = 0;
const breadcrumbs: Array<Sentry.Breadcrumb> = [];

export const toBreadcrumb = (event: ClientSessionEvent) => {
  if (event.type === 'SentryErrorEvent') return null;
  if (breadcrumbs.length >= maxBreadcrumbCount) return null;
  const breadcrumb: Sentry.Breadcrumb = {
    message: JSON.stringify(event),
    event_id: event.meta.id.toString(),
    timestamp: new Date(event.meta.date).getTime(),
  };

  const breadcrumbSize = new TextEncoder().encode(breadcrumb.message).length;

  if (totalSize + breadcrumbSize > maxBreadCrumbSize) return null;
  totalSize += breadcrumbSize;
  breadcrumbs.push(breadcrumb);
  return breadcrumb;
};

export const sentrySessionSubscriber: SessionSubscriber = {
  name: 'SessionSubscriber.Sentry',
  onInit: _noop,
  onEvent: (event) => {
    const breadcrumb = toBreadcrumb(event);
    if (!breadcrumb) return;
    Sentry.addBreadcrumb(breadcrumb);
  },
  sync: _noop,
};
